import React from 'react';
import { connect } from "react-redux";

// Components
import FreemiumFullScreenCarousel from "../components/FreemiumFullScreenCarousel";

// Actions
import { fetchActivePlaylist } from '../store/actions/playlistActions';
import { changeActiveArtwork } from '../store/actions/artworkActions';

export class Playlist extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      artwork: props.activePlaylist.data,
    }
  }

  componentWillMount() {
    const { playlistId, artworkId } = this.props;
    this.props.fetchActivePlaylist(playlistId);
    if (artworkId) {
      this.props.changeActiveArtwork(artworkId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { artwork } = this.state;
    const { activePlaylist } = nextProps;
    if (artwork.artwork === activePlaylist.data.artwork) {
      return;
    }

    if (artwork.id !== activePlaylist.data.id && artwork.name !== activePlaylist.data.name) {
      this.setState({ artwork: activePlaylist.data });
    }

  }

  render() {
    const { history, subscription } = this.props;
    const { artwork } = this.state;
    return (
      <div className="playlist-carousel_slide">
        <FreemiumFullScreenCarousel
          selectedArtwork={0}
          selectedPlaylistId={artwork.id}
          playlistName={artwork.name}
          artworks={artwork.artwork}
          history={history}
          hasSubscription={subscription}
        />
      </div>
    );
  }

}
const mapDispatchToProps = (dispatch) => ({
  fetchActivePlaylist: (targetPlaylistId) => dispatch(fetchActivePlaylist(targetPlaylistId)),
  changeActiveArtwork: (artworkId) => dispatch(changeActiveArtwork(artworkId)),
});
export default connect((state) => {
  const { device, userPlaylists, activePlaylist, activeArtwork, subscription } = state;
  return {
    device,
    userPlaylists,
    activePlaylist,
    activeArtwork,
    subscription,
  }
}, mapDispatchToProps)(Playlist);